"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceErrorToJSON = exports.ServiceErrorFromJSONTyped = exports.ServiceErrorFromJSON = void 0;
const runtime_1 = require("../runtime");
function ServiceErrorFromJSON(json) {
    return ServiceErrorFromJSONTyped(json, false);
}
exports.ServiceErrorFromJSON = ServiceErrorFromJSON;
function ServiceErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
        'property': !runtime_1.exists(json, 'property') ? undefined : json['property'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
    };
}
exports.ServiceErrorFromJSONTyped = ServiceErrorFromJSONTyped;
function ServiceErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'property': value.property,
        'message': value.message,
    };
}
exports.ServiceErrorToJSON = ServiceErrorToJSON;
//# sourceMappingURL=ServiceError.js.map